'use client'

import dynamic from 'next/dynamic'
import { Suspense } from 'react'

import { ChainLoader } from '../../../../components/chain-loader'

const DynamicFormContent = dynamic(() => import('./login-form-content').then((mod) => mod.LoginFormContent), {
  loading: () => (
    <div className="space-y-6">
      <div className="max-w-md w-full h-10 bg-gray-100 dark:bg-gray-800 rounded-md animate-pulse" />
      <div className="w-full h-10 bg-gray-100 dark:bg-gray-800 rounded-md animate-pulse" />
    </div>
  ),
  ssr: false
})

export const LoginForm = () => {
  return (
    <Suspense fallback={<ChainLoader />}>
      <div className="bg-transparent sm:bg-card rounded-xl w-full" data-testid="login-form-container">
        <DynamicFormContent />
      </div>
    </Suspense>
  )
}
